export const CHECKOUT_URL = 'https://pay.hotmart.com/W108004098B?checkoutMode=10'
export const CTA_LABEL = 'Quiero ser Inolvidable'
export const CLASS_START_ISO = '2026-10-30T00:00:00Z'

export const painParagraphs = [
  'Aprendiste con prueba y error, con rutina, con dudas que nunca preguntaste.',
  'Y mientras tanto, la rutina se instala. Las mismas caricias, el mismo orden, la misma duda de si lo estás haciendo bien.',
  'No es falta de ganas. Es falta de técnica, de anatomía real y de alguien que te lo explique sin juicios.',
]

export const desireLines = [
  'Tocar con seguridad, no con dudas.',
  'Leer el cuerpo de tu pareja, y que tu pareja lo note.',
  'Que tus caricias se recuerden al día siguiente. Y al otro.',
  'Saber qué hacer cuando empieza la pasión, y no quedarte en lo de siempre.',
]

export const forYouItems = [
  'Quieres salir de la rutina con técnica, no con improvisación.',
  'Quieres entender de verdad el cuerpo de tu pareja y el tuyo.',
  'Nadie te enseñó esto bien.',
  'Tienes preguntas que nunca te atreviste a hacer.',
  'Quieres que tu forma de tocar sea inolvidable.',
]

export type ModuleIconName = 'wave' | 'contour' | 'concentric' | 'steps'

export const modules: { number: number; icon: ModuleIconName; title: string; text: string }[] = [
  {
    number: 1,
    icon: 'wave',
    title: 'El Arte del Ritmo',
    text: 'Anatomía y placer del pene. Aprende a leer el ritmo y la respuesta del cuerpo.',
  },
  {
    number: 2,
    icon: 'contour',
    title: 'El Mapa Que Nadie Te Mostró',
    text: 'Vulva y vagina. Dónde y cómo tocar, con la anatomía real.',
  },
  {
    number: 3,
    icon: 'concentric',
    title: 'El Despertar',
    text: 'Mamas y zonas erógenas. El mapa de la piel que despierta el deseo.',
  },
  {
    number: 4,
    icon: 'steps',
    title: 'El Arte de la Confianza',
    text: 'Zona anal. Seguridad, gradación y comunicación, con respeto e higiene.',
  },
]

export const offerItems = [
  'Clase demostrativa en vivo de 2 horas con la DOC, por Zoom.',
  '4 módulos con demostración paso a paso en modelos educativos.',
  'Sesión de preguntas y respuestas, 100% anónimas.',
  'Guía INOLVIDABLE para seguir practicando cuando la clase termine.',
  'Grabación por 1 año. Velo las veces que quieras.',
  'Entras a tu manera: sola, solo o en pareja.',
]

export const steps = [
  'Reservas tu lugar en Hotmart.',
  'Recibes por correo el acceso y el link de Zoom.',
  'Entras a la clase en vivo el jueves 29 de octubre a las 9 pm (Argentina).',
  'Te llevas la guía y la grabación por 1 año.',
]

export const faqs = [
  {
    q: '¿Es explícita?',
    a: 'Es educación sexual para adultos, con modelos educativos. No se muestran cuerpos reales y las cámaras del público están apagadas.',
  },
  {
    q: '¿Mis preguntas son anónimas?',
    a: 'Sí, 100%. Las envías por escrito y la DOC las responde sin mostrar tu nombre.',
  },
  { q: '¿Tengo que ir en pareja?', a: 'No. Puedes entrar sola, solo o con tu pareja.' },
  { q: '¿Es para hombres también?', a: 'Sí. Es para toda persona mayor de 18 años.' },
  { q: '¿Qué pasa si no puedo ese día?', a: 'Tienes la grabación por 1 año para verla cuando quieras.' },
  { q: '¿Y si no me gusta?', a: 'Tienes 7 días de garantía. Hotmart te devuelve el 100%.' },
  {
    q: '¿Cuánto dura y cómo es?',
    a: '2 horas en vivo por Zoom: 4 módulos con demostración y una sesión de preguntas y respuestas.',
  },
  {
    q: '¿Qué pasa cuando se llenen los 100 lugares?',
    a: 'Se cierra la venta. No se abren más lugares.',
  },
  {
    q: '¿Esto reemplaza una consulta médica?',
    a: 'No. Es educación sexual. Para temas de salud, consulta a un profesional.',
  },
]
